import React from "react";
import {
  SFStack,
  SFDialog,
  SFUseStyled,
  SFTypography,
  SFRating,
} from "@sf-core";
import { useTranslation } from "react-i18next";

const { styled } = SFUseStyled();

const StyledStack = styled(SFStack)(({ theme }) => ({
  paddingTop: theme.spacing(2),
}));

const PopupModal = ({
  labels,
  modal,
  popupClose,
  backgroundVideo,
  modalActions,
  rating,
  setRating,
}) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <SFDialog
        backgroundVideo={backgroundVideo}
        size={"sm"}
        open={modal.open}
        divideLine
        header={
          <>
            <StyledStack direction="column" spacing={3}>
              <SFTypography variant={"detailsTotal"} component="h1">
                {t(labels.title)}
              </SFTypography>
              <SFTypography variant={"body2"}>
                {t(labels.message, {
                  value: modal.title,
                })}
              </SFTypography>
            </StyledStack>
          </>
        }
        onClose={() => popupClose()}
        actionBtns={modalActions}
      >
        <StyledStack direction={"column"} spacing={2}>
          <SFTypography variant={"body2"}>
            {t(labels.rating, {
              value: modal.title,
            })}
          </SFTypography>
          <SFRating
            value={rating}
            onChange={(e) => setRating(e)}
            size="large"
            variant="primary"
          />
        </StyledStack>
      </SFDialog>
    </React.Fragment>
  );
};

export default PopupModal;
